var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { staticClass: "popup-modal", attrs: { name: _vm.name, width: 700 } },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text" }, [
          _c("span", [_vm._t("header", [_vm._v("Header")])], 2)
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("a", [
          _c(
            "span",
            { staticClass: "modal-body-text" },
            [_vm._t("body", [_vm._v("Body")])],
            2
          ),
          _vm._v(" "),
          _c("br")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-footer" },
        [
          _c(
            "b-button",
            {
              staticClass: "modal-btn-left ap-btn secondary",
              on: {
                click: function($event) {
                  _vm.hideModal()
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.cancelText || "Cancel") + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "modal-btn-right ap-btn primary",
              on: {
                click: function($event) {
                  _vm.btnAction()
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.submitText || "Submit") + "\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2c874b6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c874b6a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/Popup.vue
// module id = 1655
// module chunks = 1